module.exports = __webpack_public_path__ + "img/work1_1.65b215f5.png";